<small>
  {{'footers.aliasInfo' | translate}}
  <a href="https://support.google.com/mail/answer/22370" target="_blank">
    {{'more' | translate}}
  </a>
</small>

<form (ngSubmit)="submit()" class="form">
  <mat-form-field appearance="outline" class="search-field">
    <input
      matInput
      [formControl]="searchControl"
      [placeholder]="'employee.searchPlaceholder' | translate"
      [attr.aria-label]="'employee.search' | translate"
    />
  </mat-form-field>
  
  <div class="employee-table-container">
    <table mat-table [dataSource]="combinedData">
    
      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef>{{ 'employee.fullName' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.fullName }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'employee.email' | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>
      
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>{{ 'employee.type' | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <div class="type-cell">
            <ng-container *ngIf="element.isAlias; else sourceBlock">
              <mat-icon class="type-icon type-icon-alias">alternate_email</mat-icon>
            </ng-container>
            <ng-template #sourceBlock>
              <ng-container [ngSwitch]="element.dataSource">
                <ng-container *ngSwitchCase="'SAMPLE'">
                  <mat-icon class="type-icon">visibility</mat-icon>
                </ng-container>
                <ng-container *ngSwitchCase="'LOCAL'">
                  <mat-icon class="type-icon">person</mat-icon>
                </ng-container>
                <ng-container *ngSwitchCase="'GOOGLE'">
                  <img src="assets/img/google-logo.svg" alt="Google" class="type-source-logo" />
                </ng-container>
                <ng-container *ngSwitchCase="'MICROSOFT'">
                  <img src="assets/img/microsoft-logo.svg" alt="Microsoft" class="type-source-logo" />
                </ng-container>
                <ng-container *ngSwitchCase="'CALAMARI'">
                  <img src="assets/img/calamari.svg" alt="Calamari" class="type-source-logo" />
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <mat-icon class="type-icon">work</mat-icon>
                </ng-container>
              </ng-container>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            color="primary"
            (change)="$event ? masterToggle() : null"
            [checked]="isAllSelected()"
            [indeterminate]="isAnySelected()"
            [disabled]="updating">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? toggleSelection(element) : null"
            [checked]="selectedItems.includes(element)"
            [disabled]="updating">
          </mat-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="toggleSelection(row)">
      </tr>
    </table>
  </div>
  
  <div class="actions">
    <button mat-raised-button [disabled]="updating || selectedItems.length === 0" (click)="submit()">
      <mat-spinner *ngIf="updating" diameter="20" class="dc-btn-spinner"></mat-spinner>
      {{ (updating ? 'footers.setting' : 'footers.install') | translate }}
    </button>
  </div>
</form>
